import { useT } from "../i18n";
import { SCREENS, USE_CASES } from "../content/shared";
import { PageHero, Reveal, Screen, Chat, Plate, InViewTitle, StepNum } from "../components/kit";
import { DownloadBand } from "./Home";
import { Demo, AppPhone } from "../components/Demo";
import D from "../content/demos";

const DEMOS = { voice: "voice", photos: "photo", "quick-messages": "lights", notifications: "coord" };

const Visual = ({ f }) => {
  const demo = f.demo || DEMOS[f.id];
  if (f.id === "plate-search") return <AppPhone plate="AB 123 CD" className="mx-auto w-full max-w-[300px]" testid="product-demo-plate-search" />;
  if (demo) return <Demo scenario={demo} plate={f.plate || USE_CASES[1].plate} className="mx-auto w-full max-w-[340px]" testid={`product-demo-${f.id}`} />;
  if (f.screen) return <div className="mx-auto w-full max-w-[300px]"><Screen src={SCREENS[f.screen]} alt={f.alt} /></div>;
  if (f.chat) return <Chat plate={f.plate || USE_CASES[1].plate} messages={f.chat} className="mx-auto w-full max-w-md" />;
  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-start gap-4 rounded-2xl border border-border bg-surface p-8">
      {(f.plates || ["AB 123 CD"]).map((p) => <Plate key={p} text={p} size="lg" />)}
    </div>
  );
};

export default function Product() {
  const { t, lang } = useT();
  const p = { ...t.product, features: [...t.product.features.slice(0, 4), ...D[lang].features, ...t.product.features.slice(4)] };
  return (
    <>
      <PageHero eyebrow={p.eyebrow} lines={p.h1} lead={p.lead} testid="product-hero" aside={
        <Reveal delay={0.3} className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <Demo scenario="photo" plate="AB 123 CD" className="mx-auto w-full max-w-[320px]" testid="product-hero-demo-photo" />
          <Demo scenario="audio" plate="AB 123 CD" className="mx-auto hidden w-full max-w-[320px] sm:mt-16 sm:block" testid="product-hero-demo-audio" />
        </Reveal>
      }>
        <nav aria-label={p.indexLabel} className="mt-10 flex flex-wrap gap-2">
          {p.features.map((f) => (
            <a key={f.id} href={`#${f.id}`} className="rounded-full border border-border px-3 py-1.5 text-sm hover:border-primary hover:text-primary" data-testid={`product-index-${f.id}`}>{f.title}</a>
          ))}
        </nav>
      </PageHero>
      <div className="border-t border-border">
        {p.features.map((f, i) => (
          <section key={f.id} id={f.id} className={`scroll-mt-24 border-b border-border ${i % 2 ? "bg-surface" : ""}`} data-testid={`product-feature-${f.id}`}>
            <div className="container-x section grid items-center gap-12 lg:grid-cols-2">
              <Reveal className={i % 2 ? "lg:order-2" : ""}>
                <StepNum n={i + 1} />
                <InViewTitle lines={f.title} className="mt-3 max-w-xl" />
                <p className="mt-4 font-display text-lg font-medium md:text-xl">{f.benefit}</p>
                <p className="mt-4 max-w-xl text-muted-foreground">{f.text}</p>
                <div className="mt-8 max-w-xl border-l-2 border-signal pl-5">
                  <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">{t.common.example}</p>
                  <p className="mt-1">{f.example}</p>
                </div>
                {f.limit && <p className="mt-6 max-w-xl text-sm text-muted-foreground">{f.limit}</p>}
              </Reveal>
              <Reveal delay={0.1} className={i % 2 ? "lg:order-1" : ""}><Visual f={f} /></Reveal>
            </div>
          </section>
        ))}
      </div>
      <div className="pt-20"><DownloadBand /></div>
    </>
  );
}
